const awsmobile =  {
    "aws_project_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_IEyUr6Wrt",
    "aws_user_pools_web_client_id": "54lj5b7bpdcgl1c06quplmnv6l" // REMEMBER: When creating app client -UNCHECK "client secret": https://medium.com/js-dojo/serverless-authentication-with-aws-amplify-and-vuex-modules-2555175df1af
};

export default awsmobile;
